/**
 * Authorization Roles
 */
const authRoles = {
  user: ['user'],
  onlyGuest: [],
};

export default authRoles;
